import app from './app.js'
import './tree.css'

const TREE = (function() {

    const switcher_close = 'switcher switcher_close'
    const switcher_open = 'switcher switcher_open'
    const switcher_noop = 'switcher switcher-noop'

    const checkboxChecked = 'checkbox checkbox-checked'
    const checkboxIndeterminate = 'checkbox checkbox-indeterminate'

    const node_content_normal = 'node-content-wrapper node-content-wrapper-normal'
    const svgEle = '<i class="anticon anticon-caret-down switcher-icon"><svg viewBox="0 0 1024 1024" width="1.5em" height="1.5em">' +
        '<path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>' +
        '</svg></i>'


    let selectNode = null

    function TREE(container, treeData) {

        //树形菜单的wraper
        this.container = container

        //所有的树形数据
        this.treeData = treeData

        //是否展示菜单
        this.show = true

        this.parent = document

        this.type = 'RootNode'

        this.children = []
        //装子节点的wrap
        this.ulElement = null

        this.renderChildren = true

        this.buildNode = function(arr, parent) {

            const _this = this

            if (arr.length) {

                arr.forEach(function(child, index) {

                    if (child.ch && child.ch.sub) {
                        let groupItem = new Group(child.$, parent, child.ch)
                        linkTreeDomAndObjGroup(groupItem)

                        if (parent.type === 'RootNode') {
                            groupItem.render()
                        }

                        parent.children.push(groupItem)

                        return _this.buildNode(child.ch.sub, groupItem)

                    } else {

                        let groupItem = new TreeItem(child.$, parent, child.ch)
                        linkTreeDomAndObjGroup(groupItem)

                        if (parent.type === 'RootNode') {
                            groupItem.render()
                        }
                        parent.children.push(groupItem)
                    }

                })

            } else {

                if (arr.ch && arr.ch.sub) {
                    let groupItem = new Group(arr.$, parent, arr.ch)
                    linkTreeDomAndObjGroup(groupItem)
                    if (parent.type === 'RootNode') {
                        groupItem.render()
                    }
                    parent.children.push(groupItem)
                    return _this.buildNode(arr.ch.sub, groupItem)
                } else {

                    let groupItem = new TreeItem(arr.$, parent)
                    linkTreeDomAndObjGroup(groupItem)
                    if (parent.type === 'RootNode') {
                        groupItem.render()
                    }
                    parent.children.push(groupItem)

                }

            }

        }

        this.renderulElement = function() {
            let ulStr = document.createElement("ul")
            ulStr.setAttribute("class", "ant-tree")
            this.ulElement = ulStr
            this.container.appendChild(ulStr)
        }

        this.init = function() {

            if (!treeData || !container) {
                console.error('没有treeData或者container')
                return
            }
            this.renderulElement()
            this.buildNode(treeData.ch.sub, this)
        }

        this.init()

    }

    //把TreeNode跟三维的ObjGroup相互关系起来
    function linkTreeDomAndObjGroup(TreeDom) {
        /*let objGroupName = 'Group_' + app.adjustName(TreeDom.objName)
        let objGroup = app.scene.getObjectByName(objGroupName)*/
        let objGroup = app.groupLinkToMesh[app.adjustName(TreeDom.objName)]
        TreeDom.obj = objGroup
        objGroup.treeObj = TreeDom
        //console.log(objGroup)
    }


    //公共的node结构
    function TreeNode(data, parent) {

        const _this = this

        this.role = data.type
        //节点id
        this.id = data.o
        //模型名字
        this.objName = data.o
        //中文名字
        //this.cnName = data.c||app.GetChinese(data.c)
        this.cnName = app.GetChinese(data.c)
        //是否选中当前节点
        this.selected = parent.selected || false
        //是否勾选
        this.checked = parent.checked || false
        //当前节点的父节点
        this.parent = parent || null
        //是否完全显示出来 checkbox状态是全部显示还是部分显示
        this.showAll = false
        //整个的dom
        this.liElement = null
        //是否已经渲染
        this.rendered = false

        //渲染展开收缩按钮
        this.getSwitcherElement = function() {

            let spanEle = document.createElement("span")

            if (this.type === 'Group') {

                spanEle.innerHTML = svgEle

                if (this.expanded) {
                    spanEle.setAttribute("class", switcher_open)
                } else {
                    spanEle.setAttribute("class", switcher_close)
                }

                //展开按钮点击事件
                spanEle.addEventListener('click', () => {

                    this.expanded = !this.expanded

                    this.renderSwitcherState()

                })

            } else {
                spanEle.setAttribute("class", switcher_noop)
            }

            return spanEle
        }

        //渲染this.expanded变化对应的ui变化  只有group有
        this.renderSwitcherState = function() {

            let ulEl = this.ulElement
            //如果已经渲染过子节点
            if (this.renderChildren) {

                let scrollHeight = ulEl.scrollHeight

                if (this.expanded) {

                    this.switcherElement.setAttribute('class', switcher_open)
                    this.ulElement.style.height = 'auto'


                } else {
                    this.switcherElement.setAttribute('class', switcher_close)
                    // 
                    this.ulElement.style.height = '0'
                }
                //渲染节点
            } else {
                this.switcherElement.setAttribute('class', switcher_open)
                if (this.children && this.children.length) {
                    this.children.forEach(item => {
                        item.render()
                    })
                }
                this.renderChildren = true
                this.expanded = true
            }
        }

        //渲染显示隐藏选择框
        this.getCheckboxElement = function() {
            let spanEle = document.createElement("span")
            if (this.checked) {
                if (this.showAll) {
                    spanEle.setAttribute('class', checkboxChecked)
                } else {
                    spanEle.setAttribute('class', checkboxIndeterminate)
                }
            } else {
                spanEle.setAttribute('class', 'checkbox')
            }
            spanEle.innerHTML = '<span class="checkbox-inner"></span>'

            //显示显示隐藏选择框点击
            spanEle.addEventListener('click', () => {
                //本来this.checked = !this.checked  但是如果不是全显示的情况下最好全显示
                this.checked = !this.showAll
                //点击系统显示属于大操作
                //显示或者隐藏app
                if (this.parent.parent === document) {
                    app.handleSelectObjbeforClickNewObj()
                    app.appendAndrejectGroup(this.obj, this.checked)
                    //如果点击显示根系统的时候 如果this没有展开就展开他
                    /*if (this.checked && !this.expanded) {
                        this.switcherElement.click()
                    }*/
                } else {
                    //显示的时候
                    app.handleSelectObjbeforClickNewObj()
                    app.selectObj.push(this.obj)
                    app.hideAndShowSelectObjGroupOption(this.checked)
                }

                this.renderCheckboxState()

            })

            return spanEle

        }

        //显示隐藏this.checked状态触发后改变并渲染一系列状态变化
        this.renderCheckboxState = function() {

            //改变当前节点所有子节点的状态
            changeChildrenCheckboxState(this, this.checked)
            //改变当前所有父节点的状态
            changeParentCheckboxState(this, this.checked)

            //处理当前节点所有子节点的隐藏显示状态
            function changeChildrenCheckboxState(treeNode, flag) {
                treeNode.showAll = treeNode.checked = flag

                let checkboxElement

                if (treeNode.rendered) {
                    checkboxElement = treeNode.checkboxElement

                    if (flag) {
                        checkboxElement.setAttribute('class', checkboxChecked)
                    } else {
                        checkboxElement.setAttribute('class', 'checkbox')
                    }
                }

                let children = treeNode.children || null

                //如果该节点是group
                if (children && children.length) {


                    for (var i = 0; i < children.length; i++) {

                        if (treeNode.renderChildren) {

                            checkboxElement = children[i].checkboxElement

                            if (flag) {
                                checkboxElement.setAttribute('class', checkboxChecked)
                            } else {
                                checkboxElement.setAttribute('class', 'checkbox')
                            }

                        }

                        changeChildrenCheckboxState(children[i], flag)
                    }

                }
            }

            //处理节点所有父节点checkbox状态
            function changeParentCheckboxState(treeNode, flag) {

                if (flag) {
                    //如果当前节点是显示操作 检查所有的父级元素是应该 '都显示'' 还是 '部分显示'
                    checkParentIfSelectedAll(treeNode)
                } else {
                    //如果当前节点是隐藏操作 检查所有的父级元素是应该 '都不显示' 还是 '部分显示'
                    checkParentIfPartSelected(treeNode)
                }

                //当现在是点击显示treeNode的情况下 检测父级节点状态是否全部显示
                function checkParentIfSelectedAll(treeNode) {

                    checkParent(treeNode)

                    function checkParent(treeNode) {

                        let parentNode = treeNode.parent
                        if (parentNode.type === 'RootNode') return

                        let children = parentNode.children
                        // 0是部分显示  1是全部显示
                        let ifShowAll = true

                        for (var i = 0; i < children.length; i++) {
                            //判断showAll就行  不用再判断checked
                            if (children[i].showAll === false) {
                                ifShowAll = false
                                break
                            }
                        }


                        if (parentNode.rendered) {
                            if (ifShowAll) {
                                parentNode.checkboxElement.setAttribute('class', checkboxChecked)
                                parentNode.showAll = true
                            } else {
                                parentNode.checkboxElement.setAttribute('class', checkboxIndeterminate)
                            }
                        }

                        parentNode.checked = true
                        parentNode.showAll = ifShowAll

                        checkParent(parentNode)

                    }
                }

                //当现在是隐藏treeNode的情况下  '都不显示' 还是 '部分显示'
                function checkParentIfPartSelected(treeNode) {

                    checkParent(treeNode)

                    function checkParent(treeNode) {

                        let parentNode = treeNode.parent
                        if (parentNode.type === 'RootNode') return

                        let children = parentNode.children
                        // 0是都不显示  1是部分显示
                        let state = 0

                        for (var i = 0; i < children.length; i++) {
                            if (children[i].checked) {
                                state = 1
                                break
                            }
                        }

                        if (parentNode.rendered) {
                            if (state) {
                                parentNode.checkboxElement.setAttribute('class', checkboxIndeterminate)
                            } else {
                                parentNode.checkboxElement.setAttribute('class', 'checkbox')
                            }
                        }

                        //隐藏了treeNode,那么父级节点肯定都是未完全显示
                        parentNode.showAll = false
                        parentNode.checked = state

                        checkParent(parentNode)

                    }
                }
            }

        }


        //渲染节点名字
        this.getNodeElement = function() {
            let spanEle = document.createElement("span")

            if (this.rendered) {
                if (this.selected) {
                    spanEle.setAttribute('class', node_content_normal + ' node-selected')
                } else {
                    spanEle.setAttribute('class', node_content_normal)
                }
            }

            spanEle.setAttribute("title", this.cnName)

            if(this.role &&this.role !== 'ZJZ'  && this.role !== 'QJBMZ'&& this.role !== 'XW'){
                spanEle.innerHTML = '<span class="title">' + this.cnName +' <a>></a> </span>'
            }else{
                spanEle.innerHTML = '<span class="title">' + this.cnName + '</span>'
            }


            spanEle.addEventListener('click', () => {
                app.clickOption(this.obj)
            })

            return spanEle
        }

        //处理this.selected状态变化后相关的业务逻辑跟渲染样式  只处理treenode状态  不包括三维世界obj
        this.renderSelectNodeState = function() {
            //如果当前是选中状态  判断是否当前group是上次点中的group 如果是就把他踢出选中队列
            /*if( this.selected && this === selectNode){
                this.selected = false
                //当前没选中 或者当前group选中了但不是上次选中的group如果是就把他选中
                }else{
                    this.selected = true
                }
            */
            //先记录下当前是要选中还是不选中 防止清除上一次选中状态的时候改变到当前要改变得状态
            let select = this.selected

            //如果当前不是多选的话先清除所有上次选中的节点的样式
            if (selectNode && !app.multi) {
                changeChildrenSelectNodeState(selectNode, false)
                selectNode = null
            }

            selectNode = this
            changeChildrenSelectNodeState(selectNode, select)

            //改变当前节点所有子节点的选中状态
            function changeChildrenSelectNodeState(treeNode, flag) {

                treeNode.selected = flag

                if (treeNode.rendered) {
                    let nodeElement = treeNode.nodeElement
                    if (flag) {
                        nodeElement.setAttribute('class', node_content_normal + ' node-selected')
                    } else {
                        nodeElement.setAttribute('class', node_content_normal)
                    }
                }

                let children = treeNode.children || null

                //如果子节点是group
                if (children && children.length) {
                    for (var i = 0; i < children.length; i++) {
                        changeChildrenSelectNodeState(children[i], flag)
                    }
                }
            }
        }


        //开始渲染节点主体
        this.render = function() {

            let liElement = document.createElement("li")

            this.switcherElement = this.getSwitcherElement()
            this.checkboxElement = this.getCheckboxElement()
            this.nodeElement = this.getNodeElement()

            liElement.appendChild(this.switcherElement)
            liElement.appendChild(this.checkboxElement)
            liElement.appendChild(this.nodeElement)

            this.liElement = liElement
            this.parent.ulElement.appendChild(liElement)

            //如果是组则渲染子节点的ul
            if (this.type === 'Group') {
                this.renderUlElement()
            }
            this.rendered = true
        }

        //状态改变更新渲染  只根据状态渲染 不改变状态值
        this.update = function(item) {
            //console.log(item)
            //if(!this.render) return
            switch (item) {
                case 'expanded':
                    if (this.type === 'Group') {
                        this.renderSwitcherState()
                    }
                    break
                case 'checked':
                    //显示隐藏操作触发后改变并渲染一系列状态变化
                    this.renderCheckboxState()
                    break
                case 'selected':
                    //选中之后处理相关的业务逻辑并渲染样式
                    this.renderSelectNodeState()
                    break

                default:
                    break

            }
        }
        //改变状态
        this.setState = function(object) {
            if (!object) return
            for (let i in object) {
                this[i] = object[i]
                this.update(i)
            }
        }

        //this.render()
    }



    function Group(data, parent, treeData) {

        this.role = data.type

        //是否展示当前节点的子节点
        this.expanded = false

        this.type = 'Group'
        //当前节点的所有子节点
        this.children = []

        //是否已经渲染完他的子节点
        this.renderChildren = false
        //当前节点数据
        this.treeData = treeData

        this.ulElement = null

        TreeNode.call(this, data, parent)

    }

    Object.assign(Group.prototype, {

        renderUlElement: function() {
            let ulStr = document.createElement("ul")
            ulStr.setAttribute("class", "child-tree")
            if (this.expanded) {
                ulStr.setAttribute("class", "child-tree child-tree-open")
            } else {
                ulStr.setAttribute("class", "child-tree child-tree-close")
            }
            this.ulElement = ulStr
            this.liElement.appendChild(ulStr)
        }

    })


    //叶子节点
    function TreeItem(data, parent) {
        TreeNode.call(this, data, parent)
        this.type = 'Item'
    }

    return TREE

})()

export default TREE


// WEBPACK FOOTER //
// ./src/pages/webgl/src/tree.js